// in src/FacebookConversion/DownloadTikTokTag.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import LanguageIcon from '@material-ui/icons/Language';
import config from 'react-global-configuration';

class DownloadTikTokTag extends Component {

    handleClick = () => {

        const webUrl = config.get('app.web_url');
        const {record } = this.props;
        window.open(`${webUrl}/tiktok-conversion-tag/${record.originId}.txt`, '_blank');
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <LanguageIcon /> &nbsp; Download TikTok tag
        </Button>;
    }
}

DownloadTikTokTag.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(DownloadTikTokTag);